// extracted by mini-css-extract-plugin
export default {"overview":"ProductOverview_overview__+Pxv0"};